import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const NonStretchedImage = props => {
    const image = getImage(props.image) || props.image;
    let alignment;
    if (props.align === 'right') {
        alignment = '0 0 0 auto'
    } else if (props.align === 'left') {
        alignment = '0 auto 0 0'
    } else {
        alignment = '0 auto'
    }

    const style = {
        ...(props.style || {}),
        margin: alignment,
    };

    if (!image || typeof image === 'string') {
        return null;
    }

    return <GatsbyImage image={image} alt={props.alt} style={style} className={props.className} />;
}

export default NonStretchedImage;